import { get, isEmpty } from 'es-toolkit/compat'
import FeatureFlagsContext, {
  type FeatureFlagsContextType,
} from 'context/feature-flags-context'
import { type ReactElement, useEffect, useState, type ReactNode } from 'react'
import Loading from 'components/loading'
import { getFeatureFlags } from 'api/feature-flags'
import { setGisProxyEnabled } from 'common/geoserver'
import { FEATURE_FLAGS } from '../../feature-flags'

type FeatureFlagsProviderProps = {
  children?: ReactNode
}
export default function FeatureFlagProvider(
  props: FeatureFlagsProviderProps,
): ReactElement<any, any> {
  const [features, setFeatures] = useState<FeatureFlagsContextType>({})
  // Children wait for the flags: map layers read gis_proxy when they are built.
  const [isLoading, setIsLoading] = useState(true)
  const { children } = props

  useEffect(() => {
    async function loadFeatureFlags() {
      try {
        const response = await getFeatureFlags()
        const data = await response.data
        if (!isEmpty(data)) {
          setFeatures(data)
        }
        setGisProxyEnabled(
          get(data, [FEATURE_FLAGS.gisProxy, 'isEnabled'], false) === true,
        )
      } catch (e) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
    loadFeatureFlags()
  }, [])
  return (
    <FeatureFlagsContext.Provider value={features}>
      {isLoading ? <Loading $fullscreen /> : children}
    </FeatureFlagsContext.Provider>
  )
}
